(function ($) {
    'use strict';

    function initUsersTable() {
        const tableElement = document.getElementById('usersTable');
        if (!tableElement) {
            return;
        }

        new DataTable('#usersTable', {
            pageLength: 25,
            order: [[1, 'asc']],
            responsive: false,
            autoWidth: false,
            columnDefs: [
                { orderable: false, targets: [8] }
            ],
            layout: {
                topStart: {
                    buttons: [
                        {
                            extend: 'collection',
                            text: '<i class="bi bi-download me-1"></i>Export',
                            attr: {class: 'btn btn-sm btn-outline-secondary'},
                            buttons: [
                                {
                                    extend: 'copyHtml5',
                                    text: '<i class="bi bi-clipboard me-1"></i>Copy',
                                    exportOptions: {
                                        columns: ':not(:last-child)'
                                    }
                                },
                                {
                                    extend: 'csvHtml5',
                                    text: '<i class="bi bi-filetype-csv me-1"></i>CSV',
                                    exportOptions: {
                                        columns: ':not(:last-child)'
                                    }
                                },
                                {
                                    extend: 'excelHtml5',
                                    text: '<i class="bi bi-file-earmark-excel me-1"></i>Excel',
                                    exportOptions: {
                                        columns: ':not(:last-child)'
                                    }
                                },
                                {
                                    extend: 'pdfHtml5',
                                    text: '<i class="bi bi-file-earmark-pdf me-1"></i>PDF',
                                    exportOptions: {
                                        columns: ':not(:last-child)'
                                    },
                                    orientation: 'landscape',
                                    pageSize: 'A4'
                                },
                                {
                                    extend: 'print',
                                    text: '<i class="bi bi-printer me-1"></i>Print',
                                    exportOptions: {
                                        columns: ':not(:last-child)'
                                    }
                                }
                            ]
                        },
                        {
                            extend: 'colvis',
                            text: '<i class="bi bi-layout-three-columns me-1"></i>Columns',
                            attr: {class: 'btn btn-sm btn-outline-secondary'}
                        }
                    ]
                },
                topEnd: {
                    search: {
                        placeholder: 'Search users'
                    }
                },
                bottomStart: 'info',
                bottomEnd: 'paging'
            }
        });
    }

    function bindEditUserModal() {
        $(document).on('click', '.btn-edit-user', function () {
            const btn = $(this);

            $('#edit_user_id').val(btn.data('user-id'));
            $('#edit_display_name').val(btn.data('display-name'));
            $('#edit_email').val(btn.data('email'));
            $('#edit_timezone').val(btn.data('timezone'));
            $('#edit_email_verified').val(btn.data('email-verified'));

            $('#edit_is_active').prop('checked', String(btn.data('is-active')) === '1');
            $('#edit_is_platform_admin').prop('checked', String(btn.data('is-platform-admin')) === '1');
        });
    }

    $(function () {
        initUsersTable();
        bindEditUserModal();
    });

})(jQuery);